import { CountryIsoNumber } from '../../models/country/country-iso-number.enum';
import { CurrencyCode } from '../../models/currency/currency-code.enum';

export function defaultCurrencyCodeFactory(
  countryIsoNumber: CountryIsoNumber,
): CurrencyCode {
  switch (countryIsoNumber) {
    case CountryIsoNumber.Ireland:
      return CurrencyCode.Euro;
    case CountryIsoNumber.GreatBritain:
    default:
      return CurrencyCode.PoundSterling;
  }
}
